var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import DataForm from "~/components/common/data-form.vue";
import AssistAllocate from "~/components/case-info/case-allot/assist-allocate.vue";
import { Prop, Emit } from "vue-property-decorator";
import { Getter, namespace } from "vuex-class";
import { Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { DataGrid, DataGridItem } from "@zct1989/vue-component";
import { AssistCaseService } from "~/services/business-service/assist-case.service";
import { UserService } from "~/services/manage-service/user.service";
var systemManageModule = namespace("system-manage");
var AssistCaseAllot = /** @class */ (function (_super) {
    __extends(AssistCaseAllot, _super);
    function AssistCaseAllot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectionUserList = [];
        _this.userDataList = [];
        _this.distributeConfigModel = {};
        _this.userModel = {
            userName: "",
            realName: "",
            departCode: ''
        };
        _this.totalCases = 0;
        _this.totalAmt = 0;
        _this.model = {};
        _this.loading = {
            state: false
        };
        _this.dialog = {
            personalManualDivisionNext: false
        };
        return _this;
    }
    AssistCaseAllot.prototype.close = function () {
        this.dialog.personalManualDivisionNext = false;
        var databox = this.$refs["user-data-box"];
        databox.clearSelection();
    };
    AssistCaseAllot.prototype.onSuccess = function () {
        this.close();
    };
    Object.defineProperty(AssistCaseAllot.prototype, "totalPerson", {
        get: function () {
            return this.selectionUserList.length;
        },
        enumerable: false,
        configurable: true
    });
    AssistCaseAllot.prototype.resetForm = function () {
        var form = this.$refs['user-form'];
        form.resetFields();
    };
    AssistCaseAllot.prototype.refreshUserData = function () {
        var _this = this;
        this.userService.findUserByDepartmentCode(this.userModel, this.sortService).subscribe(function (data) {
            _this.userDataList = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    /**
     * 下一步，进入分配确认阶段
     */
    AssistCaseAllot.prototype.nextStep = function () {
        var _this = this;
        if (this.selectionUserList.length == 0) {
            this.$message.info("请选择要分配的调解员!");
            return;
        }
        var ids = this.selectionCases.map(function (x) { return x.id; });
        var distributeConfigModels = this.selectionUserList.map(function (x) {
            var assistDistributeModel = {
                // 分配人员ID
                userId: x.id,
                // 员工工号
                userName: x.username,
                // 全名
                realName: x.realName,
                // 分配数量
                caseNumTotal: 0,
                // 分配金额
                leftAmtTotal: 0,
                // 百分比
                perNum: 0,
            };
            return assistDistributeModel;
        });
        this.model = {
            // 案件Ids
            caseIds: ids,
            // 案件总数
            caseNumTotal: this.totalCases,
            // 案件总金额
            caseAmtTotal: this.totalAmt,
            // 调解员总数
            collectorTotal: this.selectionUserList.length,
            // 分配规则
            distributeConfigModels: distributeConfigModels,
        };
        this.loading.state = true;
        this.assistCaseService.assistCaseDistributePre(this.model, this.loading).subscribe(function (data) {
            _this.distributeConfigModel = data;
            _this.dialog.personalManualDivisionNext = true;
        }, function (error) {
            _this.$message.error(error.msg);
        });
    };
    Object.defineProperty(AssistCaseAllot.prototype, "allocationNumber", {
        get: function () {
            return this.selectionUserList.length;
        },
        enumerable: false,
        configurable: true
    });
    AssistCaseAllot.prototype.handleNodeClick = function (node) {
        this.userModel.departCode = node.departCode;
        this.refreshUserData();
    };
    AssistCaseAllot.prototype.refreshData = function () {
        // 计算总金额
        this.totalAmt = this.selectionCases
            .map(function (x) { return x.leftAmt; }).reduce(function (result, item) { return result + Number(item); });
        // 获取总案件
        this.totalCases = this.selectionCases.length;
    };
    __decorate([
        Dependencies(PageService)
    ], AssistCaseAllot.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AssistCaseAllot.prototype, "sortService", void 0);
    __decorate([
        Dependencies(AssistCaseService)
    ], AssistCaseAllot.prototype, "assistCaseService", void 0);
    __decorate([
        Dependencies(UserService)
    ], AssistCaseAllot.prototype, "userService", void 0);
    __decorate([
        Getter
    ], AssistCaseAllot.prototype, "orgTreeData", void 0);
    __decorate([
        Prop({})
    ], AssistCaseAllot.prototype, "selectionCases", void 0);
    __decorate([
        Emit("close")
    ], AssistCaseAllot.prototype, "close", null);
    __decorate([
        Emit("success")
    ], AssistCaseAllot.prototype, "onSuccess", null);
    AssistCaseAllot = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                DataForm: DataForm,
                DataGrid: DataGrid,
                DataGridItem: DataGridItem,
                AssistAllocate: AssistAllocate
            }
        })
    ], AssistCaseAllot);
    return AssistCaseAllot;
}(Vue));
export default AssistCaseAllot;
